



































































import {Vue, Component} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from "@/services/data-proxy.service";
import moment from "moment";

@Component
export default class ObracunStimulacijeVozacima extends mixins(ComponentBaseMixin) {
    zvtFile = null;
    vl06fFile = null;
    isBusy = false;
    isProcessing = false;
    isClosing = false;
    odDatuma;
    doDatuma;
    select2Options = {
        minimumResultsForSearch: Infinity
    };
    errors = [];
    columns = [];
    tableOptions = {
        search: true,
        showExport: true,
        exportTypes: ['excel']
    }

    created() {
        let month = moment().get('month');
        const year = moment().get('year');

        if (month > 2) {
            month = month - 1;
        }

        this.odDatuma = new Date(year, month - 1, 26, 2);
        this.doDatuma = new Date(year, month, 25, 2);
        this.columns = [
            {field: 'level', width: 80, formatter: value => value === 0 ?
                    '<i class="fa fa-warning text-warning"></i>' : '<i class="fa fa-exclamation-triangle text-danger"></i>'},
            {field: 'message', title: this.$i18n.t("poruka")}
        ]
    }

    async uvezi() {
        this.isBusy = true;
        try {
            await this.saveData(() => dataProxy.uveziPodatkeZaObracunStimulacije(this.zvtFile, this.vl06fFile))();
        } catch (e) {
            this.showError(<string>this.$i18n.t('nesupesnoCuvanjePodataka'));
        } finally {
            this.isBusy = false;
        }
    }

    async obracunaj() {
        this.isProcessing = true;
        try {
            const errors = await this.saveData(() => dataProxy.obracunajStimulacijuVozacima(this.odDatuma, this.doDatuma))();
            this.errors = errors;
        } catch (e) {
            this.showError(<string>this.$i18n.t('nesupesnoCuvanjePodataka'));
        } finally {
            this.isProcessing = false;
        }
    }

    async zakljuci() {
        this.isClosing = true;
        try {
            await this.saveData(() => dataProxy.zakljuciObracunStimulacijeVozacima(this.odDatuma, this.doDatuma))();
        } catch (e) {
            this.showError(<string>this.$i18n.t('nesupesnoCuvanjePodataka'));
        } finally {
            this.isClosing = false;
        }
    }
}
